<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    @click:primary="gerarRelatorio"
  >
    <div class="d-flex align-center">
      <div class="w-50-porcento pr-2">
        <SysGrupoAutocomplete
          v-model="filtros.grupos"
          label="Grupos"
          outlined
          multiple
          :error-messages="GRUPO_ERRORS"
        />
      </div>

      <div class="w-50-porcento pl-2">
        <SysFilialGrupoAutocomplete
          v-model="filtros.filial"
          label="Filial"
          outlined
          :ids-grupo="filtros.grupos"
          :unshift-items="{id: -1, descricao: 'Todas'}"
          :error-messages="FILIAL_ERRORS"
        />
      </div>
    </div>

    <div class="d-flex align-center mb-n4">
      <div class="w-50-porcento pr-2">
        <SysDatePicker
          v-model="filtros.data_inicial"
          outlined
          titulo_label="Data Inicial"
          :error-messages="DATA_INI_ERRORS"
        />
      </div>

      <div class="w-50-porcento pl-2">
        <SysDatePicker
          v-model="filtros.data_final"
          titulo_label="Data Final"
          outlined
          :error-messages="DATA_FIN_ERRORS"
        />
      </div>
    </div>

    <SysCompradorAutocomplete
      v-model="filtros.compradores"
      outlined
      multiple
      hide-details
      class="mt-4"
      label="Compradores"
      :idsGrupo="filtros.grupos"
      :idsFilial="filtros.filiais"
      :qtde_visivel_selecionados="1"
    />

    <SysFornecedorAutocomplete
      v-model="filtros.fornecedores"
      outlined
      multiple
      hide-details
      class="mt-4"
      label="Fornecedores"
      :idsGrupo="filtros.grupos"
      :idsFilial="filtros.filiais"
      :idsComprador="filtros.compradores"
      :qtdeVisivelSelecionados="1"
    />
  </SysDialog>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Mixin from "@/components/Relatorios/Mixin";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import $axios from "@/api/api";
import SysDatePicker from '@/components/utils/SysDatePicker.vue';
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete.vue";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete.vue";

export default {
  name: "Exemplo",
  mixins: [Mixin],
  components: {
    SysFilialGrupoAutocomplete,
    SysGrupoAutocomplete,
    SysDatePicker,
    SysCompradorAutocomplete,
    SysFornecedorAutocomplete
  },
  data: () => ({
    filtros: {
      grupos: [],
      filial: -1,
      data_inicial: '',
      data_final: '',
      compradores: [],
      fornecedores: []
    }
  }),
  computed: {
    GRUPO_ERRORS() {
      const errors = [];
      if (!this.$v.filtros.grupos.$dirty) return errors;
      !this.$v.filtros.grupos.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    FILIAL_ERRORS() {
      const errors = [];
      if (!this.$v.filtros.filial.$dirty) return errors;
      !this.$v.filtros.filial.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    DATA_INI_ERRORS() {
      const errors = [];
      if (!this.$v.filtros.data_inicial.$dirty) return errors;
      !this.$v.filtros.data_inicial.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    DATA_FIN_ERRORS() {
      const errors = [];
      if (!this.$v.filtros.data_final.$dirty) return errors;
      !this.$v.filtros.data_final.required && errors.push("Campo Obrigatório.");
      return errors;
    },
  },
  methods: {
    gerarRelatorio() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const url = `${this.relatorio.url}${this.Helpers.formatarParametrosObjParaUrl(this.filtros)}`;
      window.open(`${$axios.defaults.baseURL}/${url}`, "_blank");
      this.DIALOG_ATIVO = false;
    }
  },
  validations: {
    filtros: {
      grupos: { required },
      filial: { required },
      data_inicial: { required },
      data_final: { required },
    }
  }
}
</script>

<style scoped>

</style>
